import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { listEmptyStateMarkup } from './listEmptyStateMarkup';
/** The list's explanation and next action, shared by React, guest review and
 * server-rendered reports. Each host owns its data and recovery operation. */
export function ListEmptyState({ title, hint, action, className = '', error = false }) {
    return _jsxs("div", { className: `oq-auto-review-ui oq-list-empty ${className}`, role: error ? 'alert' : 'status', children: [_jsx("div", { className: "oq-list-empty__copy", dangerouslySetInnerHTML: { __html: listEmptyStateMarkup(title, hint) } }), action] });
}
//# sourceMappingURL=ListEmptyState.js.map